import React, {createContext, useContext, useState, FC, ReactNode, useEffect} from 'react'
import {AuthErrorModal} from '../components/AuthErrorModal'
import {setGlobalShowDialog, setGlobalTokenExpirationHandler} from './AuthErrorInterceptor'
import {useCognitoAuth} from './CognitoAuth'

interface AuthErrorContextType {
  showAuthErrorDialog: () => void
  hideAuthErrorDialog: () => void
}

const AuthErrorContext = createContext<AuthErrorContextType | undefined>(undefined)

export const useAuthError = () => {
  const context = useContext(AuthErrorContext)
  if (!context) {
    throw new Error('useAuthError must be used within an AuthErrorProvider')
  }
  return context
}

interface AuthErrorProviderProps {
  children: ReactNode
}

export const AuthErrorProvider: FC<AuthErrorProviderProps> = ({children}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {handleTokenExpiration} = useCognitoAuth()

  const showAuthErrorDialog = () => {
    setIsModalOpen(true)
  }

  const hideAuthErrorDialog = () => {
    setIsModalOpen(false)
  }

  // Set the global functions when the provider mounts
  useEffect(() => {
    setGlobalShowDialog(showAuthErrorDialog)
    setGlobalTokenExpirationHandler(handleTokenExpiration)
  }, [handleTokenExpiration])

  return (
    <AuthErrorContext.Provider value={{showAuthErrorDialog, hideAuthErrorDialog}}>
      {children}
      <AuthErrorModal isOpen={isModalOpen} onClose={hideAuthErrorDialog} />
    </AuthErrorContext.Provider>
  )
}
